module.exports = __webpack_public_path__ + "img/Galactapedia_Crusader_Industries.22a45f45.png";